import { createApp } from "vue";
import { useGlobalState, VueDataStateKey } from "@/core/composables/global-state";
import { useToastNotificationStore } from "@/experiences/toast-notifications/store/toast-notifications";
import { i18n } from "@/core/i18n";
// Components
import NotificationsView from "@/experiences/toast-notifications/views/ToastNotificationsView.vue";
export default {
    install: (_app) => {
        const globalState = useGlobalState();
        if (globalState.get(VueDataStateKey.ToastNotificationsInitialized))
            return;
        const elId = "v-toast-notifier";
        let el = document.getElementById(elId);
        if (!el) {
            el = document.createElement("div");
            el.id = elId;
            document.body.append(el);
        }
        if (el.__vue_app__)
            return;
        globalState.set(VueDataStateKey.ToastNotificationsInitialized, true);
        const toastApp = createApp(NotificationsView);
        toastApp.config.globalProperties.$t = _app.config.globalProperties.$t;
        // Since toastApp is a standalone app (not created via initializeVue), i18n must be explicitly
        // provided so that inject("i18n") works in stores and composables used within this app.
        toastApp.provide("i18n", i18n);
        toastApp.mount(el);
        const notificationsStore = useToastNotificationStore();
        window.Ramius.notifier = {
            addNotice: notificationsStore.legacyAddNotice
        };
    }
};
